import { Component, Input } from '@angular/core';

@Component({ selector: 'app-streak-kickoff', template: `
<section class="kickoff" aria-label="Getting ready for the streak">
  <div class="starting-line" aria-hidden="true"><span>✦</span><i class="fa fa-shoe-prints"></i><span class="flag">⚑</span><span>✧</span></div>
  <h2>{{ team ? 'Team laced up. Let’s go!' : 'Lace up. Your streak is coming!' }}</h2>
  <p *ngIf="startDate">The fun starts {{ startDate | date:'MMMM d' }}.</p>
  <p>{{ team ? 'Team stats and activities will appear once the streak begins. Gather your crew and get ready!' : 'Stats and activities will appear once the streak begins. Get ready to make every day count!' }}</p>
</section>`, styles: [`
:host{display:block;} .kickoff{text-align:center;padding:clamp(24px,5vw,48px) 20px;background:var(--dw-fitness-mint,#e5f1e8);color:var(--dw-fitness-green,#123d30);border-radius:16px;}
.starting-line{display:flex;align-items:center;justify-content:center;gap:20px;max-width:280px;margin:0 auto 24px;padding:20px 0;border-bottom:4px dashed currentColor;font-size:28px;}
.fa-shoe-prints{font-size:56px;transform:rotate(-25deg);} .flag{font-size:64px;line-height:1;} h2{font-size:1.3rem;margin:0 0 12px;} p{max-width:440px;margin:8px auto;line-height:1.6;}
`] })
export class StreakKickoffComponent {
    @Input() team = false;
    @Input() startDate: string;
}
